// File: src/views/About.js

import React from 'react';
import styles from './About.module.css';
import AboutHero from '../components/about/AboutHero';
import Team from '../components/about/Team';
import Research from '../components/about/Research';
import Innovation from '../components/about/Innovation';
import Community from '../components/about/Community';
import SustainabilityGoals from '../components/impact/SustainabilityGoals';

function About() {
  return (
    <div className={styles.page}>
      <AboutHero />
      <Team />
      <Research />
      <Innovation />
      <Community />
      <SustainabilityGoals />
    </div>
  );
}

export default About;